import { render, staticRenderFns } from "./Gantt.vue?vue&type=template&id=2d449490&scoped=true&"
import script from "./Gantt.vue?vue&type=script&lang=js&"
export * from "./Gantt.vue?vue&type=script&lang=js&"
import style0 from "./Gantt.vue?vue&type=style&index=0&id=2d449490&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d449490",
  null
  
)

export default component.exports